module.exports = __webpack_public_path__ + "img/1FFWqX_Cpu0vXZYeXzpddmZLTw-3p-Mgr.930abb71.png";